export class countRangeWiseInfo {
    name: string;
    y: number;
    drilldown?: string;
    label?:string
    /**
     * 
     * @param name
     * @param y
     * @param drilldown
     */
    constructor(name: string,y: number,drilldown?: string,label?:string) {
        this.name = name;
        this.y = y;
        this.drilldown = drilldown;
        this.label = label;
    }
}